
import React, { useEffect, useRef,useState } from "react"

import { BrowserRouter,Routes, Route } from 'react-router';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/styles.css';

import {Header}  from "./pages/Header";
import {Footer}  from "./pages/Footer";
import {Home}  from "./pages/Home";
import {Edito} from "./pages/Edito";
import {Faq} from "./pages/Faq";
import {EnCeMoment} from "./pages/EnCeMoment";
import {Contact} from "./pages/Contact";
import {Calendrier} from "./pages/Calendrier";
import {DownloadModalComponent} from "./pages/ModalProspection";
import {PageToutSavoir} from "./pages/PageToutSavoir";
import {Rubrique} from "./pages/Rubrique";
import {Article} from "./pages/Article";
import {PilierLutte} from "./pages/PilierLutte";
import {PartenairePage} from "./pages/PartenairePage";
import {CalendrierVide} from "./pages/CalendrierVide";
import {Recherche} from "./pages/Recherche";
import {SearchModalComponent} from "./pages/ModalSearch";
import ScrollToTop from "./pages/ScrollToTop";

function App() {

  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const openDownloadModal = (e) => {
    e.preventDefault();
    setShowDownloadModal(true);
  };

  const closeDownloadModal = () => setShowDownloadModal(false);


  const [showSearchModal, setShowSearchModal] = useState(false);
  const openSearchModal = (e) => {
    e.preventDefault();
    setShowSearchModal(true);
  };

  const closeSearchModal = () => setShowSearchModal(false);

  return (
      <>
        <BrowserRouter>
          <ScrollToTop />
          <DownloadModalComponent
              showModal={showDownloadModal}
              closeModal={closeDownloadModal}
          />
          <SearchModalComponent
              showModal={showSearchModal}
              closeModal={closeSearchModal}
          />
          <Header openDownloadModal={openDownloadModal}  openSearchModal={openSearchModal} />
          <Routes>
            <Route path="/" element={<Home openDownloadModal={openDownloadModal} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/en-ce-moment-dans-le-vignoble" element={<EnCeMoment />} />
            <Route path="/mentions-legales" element={<Edito idContent="1" />} />
            <Route path="/politique-protection" element={<Edito idContent="2" />} />
            <Route path="/partenaires" element={<PartenairePage />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/faq/:idFaq" element={<Faq />} />
            <Route path="/recherche/:search" element={<Recherche />} />
            <Route path="/tout-savoir-sur-la-flavescence-doree" element={<PageToutSavoir />} />
            <Route path="/tout-savoir-sur-la-flavescence-doree/:wording" element={<Rubrique />} />
            <Route path="/tout-savoir-sur-la-flavescence-doree/organisation-de-la-lutte/:wordingPilier" element={<PilierLutte wording='organisation-de-la-lutte' />} />
            <Route path="/tout-savoir-sur-la-flavescence-doree/:wording/:id" element={<Article />} />
            <Route path="/tout-savoir-sur-la-flavescence-doree/plus/:wording/:id" element={<Article plus="1" />} />
            <Route path="/calendrier-prospection" element={<CalendrierVide />} />
            <Route path="/calendrier-prospection/:idCommune" element={<Calendrier openDownloadModal={openDownloadModal} />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </>
  );
}

export default App;
